export interface SliderScale {
  readonly minValue: number;
  readonly maxValue: number;
  position(value: number): number;
  value(position: number, didDrag?: boolean): number;
}

export class LinearSliderScale implements SliderScale {
  private readonly _start: number;
  private readonly _length: number;
  private readonly _end: number;

  constructor(start: number, end: number) {
    this._start = start;
    this._end = end;
    this._length = end - start;
  }

  position(value: number): number {
    // TODO: probably move this to an internal adapter so everyone doesn't have
    //     | to implement this check.
    if (this._start === this._end) {
      return 0;
    }
    return (value - this._start) / this._length;
  }

  value(position: number): number {
    return position * this._length + this._start;
  }

  get minValue() {
    return this._start;
  }

  get maxValue() {
    return this._end;
  }

  static createFromLength(start: number, length: number) {
    return new LinearSliderScale(start, start + length);
  }

  static createFromMinMax(start: number, end: number) {
    return new LinearSliderScale(start, end);
  }
}
